import { Component, input, OnInit, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'rc-commands-filter-device-ids-commands-filter',
  templateUrl: './device-ids-commands-filter.component.html',
  styleUrls: ['./device-ids-commands-filter.component.scss'],
  imports: [
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatBadge,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    FormsModule,
    MatSuffix,
  ],
})
export class DeviceIdsCommandsFilterComponent implements OnInit {
  isFilterHidden = true;
  title = 'Device IDs';
  showSearch = true;

  refresh = output<boolean>();
  changeDeviceIdsStringList = output<string>();
  deviceIdsStringList = input('');

  ngOnInit() {
    this.isFilterHidden = !this.deviceIdsStringList();
  }

  toggleShowFilter() {
    this.isFilterHidden = !this.isFilterHidden;
  }

  onEnableFilterToggled(checked: boolean) {
    if (!checked) this.changeDeviceIdsStringList.emit(undefined);
    this.isFilterHidden = !checked;
  }

  onClick() {
    this.showSearch = !this.showSearch;
  }

  onReset() {
    this.changeDeviceIdsStringList.emit('');
    this.refresh.emit(true);
  }

  onChangeValue($event: string) {
    this.changeDeviceIdsStringList.emit($event);
    this.refresh.emit(true);
  }
}
